/* 260810要件: まとめ買いレコメンド
   チェック済み商品をまとめてカートに追加し、カートページへ遷移する。
   GA4計測用に pakari_bundle_view / pakari_bundle_add_to_cart を発行する。 */

if (!customElements.get('bundle-recommend')) {
  customElements.define(
    'bundle-recommend',
    class BundleRecommend extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.bundle-recommend__button');
        this.buttonLabel = this.button ? this.button.querySelector('span') : null;
        this.defaultLabel = this.buttonLabel ? this.buttonLabel.textContent : '';
        this.errorBox = this.querySelector('.bundle-recommend__error');
        this.submitting = false;

        // チェックボックス操作がカードのリンク等へ伝播しないようにする
        this.addEventListener('click', (ev) => {
          const label = ev.target && ev.target.closest ? ev.target.closest('.bulk-select-checkbox') : null;
          if (label) ev.stopPropagation();
        });

        // チェック変更で件数・総額を更新する（260810修正: 総額表示）
        this.totalValue = this.querySelector('.bundle-recommend__total-value');
        this.totalCount = this.querySelector('.bundle-recommend__total-count');
        this.addEventListener('change', (ev) => {
          if (ev.target && ev.target.classList.contains('bulk-select-checkbox__input')) {
            this.updateTotal();
          }
        });

        // ブラウザ戻る（bfcache復元）でカート追加時のloading状態が残る不具合の対策（260810修正）
        this.onPageShow = () => {
          this.submitting = false;
          this.setLoading(false);
          if (this.errorBox) this.errorBox.hidden = true;
          this.updateTotal();
        };
        window.addEventListener('pageshow', this.onPageShow);

        if (this.button) {
          this.button.addEventListener('click', () => this.addToCart());
        }

        this.observeView();
      }

      disconnectedCallback() {
        if (this.onPageShow) window.removeEventListener('pageshow', this.onPageShow);
      }

      checkedInputs() {
        return Array.prototype.slice
          .call(this.querySelectorAll('.bulk-select-checkbox__input'))
          .filter((input) => input.checked);
      }

      collectItems(inputs) {
        return inputs.map((input, i) => ({
          item_id: input.dataset.productId,
          item_name: input.dataset.productTitle,
          price: Number(input.dataset.price) || 0,
          quantity: 1,
          index: i + 1,
        }));
      }

      updateTotal() {
        const inputs = this.checkedInputs();
        if (this.totalCount) {
          this.totalCount.textContent = String(inputs.length);
        }
        if (this.totalValue) {
          const sum = inputs.reduce((acc, input) => acc + (Number(input.dataset.price) || 0), 0);
          this.totalValue.textContent = '¥' + Math.round(sum).toLocaleString('ja-JP');
        }
        // 0件時はボタンをグレーアウトし文言を切り替える（260810修正3）
        if (this.button) {
          const empty = inputs.length === 0;
          this.button.disabled = empty;
          if (this.buttonLabel) {
            this.buttonLabel.textContent = empty ? '商品を選択してください' : this.defaultLabel;
          }
        }
      }

      publish(name, payload) {
        const a = window.Shopify && window.Shopify.analytics;
        if (!a || typeof a.publish !== 'function') return;
        a.publish(name, payload);
      }

      observeView() {
        const send = () => {
          if (this.viewSent) return;
          this.viewSent = true;
          const items = this.collectItems(
            Array.prototype.slice.call(this.querySelectorAll('.bulk-select-checkbox__input'))
          );
          this.publish('pakari_bundle_view', {
            item_list_id: 'bundle_recommend',
            item_list_name: 'まとめ買いレコメンド',
            items: items,
          });
        };
        if ('IntersectionObserver' in window) {
          const io = new IntersectionObserver((entries) => {
            entries.forEach((e) => {
              if (e.isIntersecting) {
                send();
                io.disconnect();
              }
            });
          }, { threshold: 0.2 });
          io.observe(this);
        } else {
          send();
        }
      }

      showError(message) {
        if (!this.errorBox) return;
        this.errorBox.textContent = message;
        this.errorBox.hidden = false;
      }

      setLoading(on) {
        if (!this.button) return;
        this.button.classList.toggle('loading', on);
        this.button.setAttribute('aria-disabled', on ? 'true' : 'false');
        const spinner = this.button.querySelector('.loading__spinner');
        if (spinner) spinner.classList.toggle('hidden', !on);
      }

      addToCart() {
        if (this.submitting) return;
        const inputs = this.checkedInputs();
        if (inputs.length === 0) return; // チェック0件は反応なし（要件）

        this.submitting = true;
        this.setLoading(true);
        if (this.errorBox) this.errorBox.hidden = true;

        const body = JSON.stringify({
          items: inputs.map((input) => ({
            id: Number(input.dataset.variantId),
            quantity: 1,
          })),
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || 'カートに追加できませんでした。');
              return;
            }
            const items = this.collectItems(inputs);
            this.publish('pakari_bundle_add_to_cart', {
              item_list_id: 'bundle_recommend',
              item_list_name: 'まとめ買いレコメンド',
              currency: 'JPY',
              value: items.reduce((sum, it) => sum + it.price * it.quantity, 0),
              item_count: items.length,
              items: items,
            });
            // 計測イベントの送信猶予を置いてからカートへ遷移する
            setTimeout(() => {
              window.location.href = routes.cart_url;
            }, 400);
            return true;
          })
          .catch(() => {
            this.showError('通信エラーが発生しました。時間をおいてお試しください。');
          })
          .finally(() => {
            this.submitting = false;
            // 遷移までボタンはloadingのままにする（成功時）。エラー時のみ解除
            if (this.errorBox && !this.errorBox.hidden) this.setLoading(false);
          });
      }
    }
  );
}
